import intl from 'react-intl-universal'

export default {
  type: 'numeric_rating',
  title: `Rating`,
  icon: `star-half-o`,
  template: `
        <div contenteditable="false" feature-obj="feature" org-index="orgIndex" class="">
          <span ng-show="feature.type == 'numeric_rating'">
            <b>{{feature.additional_properties.uiType}}</b>:&nbsp;
            {{feature.numeric_rating}} ${intl.get(
              'blocks.rating.outOf'
            )} {{feature.max}} {{feature.units}}
          </span>
          <span ng-show="feature.type == 'endorsement'">
            <b>{{feature.additional_properties.uiType}}</b>:&nbsp;
            ${intl.get('blocks.rating.endorsement')}: {{feature.endorsement}}
          </span>
        </div>`,
  propertyTemplate: `<rating-property-editor feature="feature"/>`,
  initialInflation: function () {
    return {
      type: 'numeric_rating',
      numeric_rating: 4.5,
      min: 0,
      max: 5,
      units: 'stars',
    }
  },
  openPropertyTemplateOnAdd: true,
}
